import * as _jqueryValidate from './../utils/jquery.validate.custom';
import * as _utils from './../utils/wappo.utils';

var searchCategories = [];

$(document).ready(function ()
{
	// module initialization
	InitModule();
});

function InitModule()
{
	// preload filter panel
	LoadFilter()

	// init filters box
	InitFiltersBox();

	// init news like
	InitNewsLike();
}

function InitFiltersBox()
{
	// category click
	$('#CategoriesList li span').click(function (e)
	{
		e.stopPropagation();

		var categoryId = $(this).closest('li').data('id');

		if (searchCategories.indexOf(categoryId) >= 0)
			searchCategories.splice($.inArray(categoryId, searchCategories), 1);
		else
			searchCategories.push(categoryId);

		// search for children
		//if ($(this).closest('li').children('ul'))
		//{
		//	var childList = $(this).closest('li').children('ul').first();

		//	$(childList).children('li').each(function ()
		//	{
		//		var subCategoryId = $(this).data('id');

		//		// parent category is selected
		//		if (searchCategories.indexOf(categoryId) >= 0)
		//		{
		//			if (searchCategories.indexOf(subCategoryId) < 0)
		//				searchCategories.push(subCategoryId);
		//		}
		//		else
		//			searchCategories.splice($.inArray(subCategoryId, searchCategories), 1);
		//	});
		//}

		UpdateActiveCategories();
	});

	// form submit
	$('#SearchNewsForm').submit(function (e)
	{
		e.preventDefault();

		var textQuery = $('#filter').val();
		var productQuery = $('#productFilter').val();
		var tagQuery = $('#tagFilter').val();
		var categoriesQuery = "";
		searchCategories.forEach(function (item)
		{
			categoriesQuery += item + ';'
		});
		var areaQuery = $('#area').val();

		// redirect uri
		var redirectUri = "/news?s=1";
		if (textQuery)
			redirectUri += "&query=" + textQuery;
		if (productQuery)
			redirectUri += "&product=" + productQuery;
		if (tagQuery)
			redirectUri += "&tag=" + tagQuery;
		if (categoriesQuery)
			redirectUri += "&categories=" + categoriesQuery;
		if (areaQuery)
			redirectUri += "&area=" + areaQuery;

		window.location.href = redirectUri;
	});

	// reset
	$('#ResetButton').click(function (e)
	{
		window.location.href = '/news';
	});

	// reset
	$('#ExportNewsButton').click(function (e)
	{
		var textQuery = $('#filter').val();
		var productQuery = $('#productFilter').val().split(',').filter(Boolean);
		var tagQuery = $('#tagFilter').val().split(',').filter(Boolean);
		var categoriesQuery = searchCategories;
		var areaQuery = $('#area').val() > 0 ? $('#area').val() : null;

		console.log($(location).attr('href'));

		var _postData =
		{
			text: textQuery,
			product: productQuery,
			tag: tagQuery,
			categories: categoriesQuery,
			area: areaQuery,
			url: $(location).attr('href')
		};

		$.ajax({
			type: "POST",
			url: '/umbraco/Surface/NewList/ExportExcel',
			data: _postData,
			xhrFields: { responseType: 'blob' },
			success: function (blob)
			{
				if (blob && blob.size > 0)
				{
					var downloadUrl = URL.createObjectURL(blob);
					var a = document.createElement('a');
					a.href = downloadUrl;
					a.download = 'Gilead REG news.xlsx';
					document.body.appendChild(a);
					a.click();
				}
				else
				{
					alert("Nessun risultato per la ricerca specificata.");
				}
			},
			error: function (jqXHR, textStatus, errorThrown)
			{
				console.log(jqXHR);
			}
		});
	});
}

function InitNewsLike()
{
	// check: already liked
	$(document).ready(function ()
	{
		var newsId = $('#LikeButton').data('id');
		CheckNewsLike(newsId);
	});

	$('#LikeButton').click(function (e)
	{
		e.preventDefault();

		var newsId = $(this).data('id');

		// check: already liked
		if (!localStorage.getItem('news-like-' + newsId))
		{
			$('#DislikeButton').hide();
			$('#LikeButton').addClass('loading');

			LikeDislike(newsId, true);
		}
		else
		{
			alert("Hai già mandato la tua preferenza per questa notizia!");
		}
	});

	$('#DislikeButton').click(function (e)
	{
		e.preventDefault();

		var newsId = $(this).data('id');

		// check: already liked
		if (!localStorage.getItem('news-like-' + newsId))
		{
			$('#LikeButton').hide();
			$('#DislikeButton').addClass('loading');

			LikeDislike(newsId, false);
		}
		else
		{
			alert("Hai già mandato la tua preferenza per questa notizia!");
		}
	});
}

function LikeDislike(newsId, like)
{
	$.ajax({
		type: "POST",
		url: '/umbraco/Surface/NewList/Like',
		data: { id: newsId, like: like },
		success: function ()
		{
			localStorage.setItem('news-like-' + newsId, like);

			// update like panel
			CheckNewsLike(newsId);
		},
		error: function (jqXHR, textStatus, errorThrown)
		{
			$('#LikeButton').removeClass('loading');
		}
	});
}

function CheckNewsLike(newsId)
{
	if (!localStorage.getItem('news-like-' + newsId))
	{
		$('.liked-box').hide();
		$('.like-box').show();
	}
	else
	{
		$('.liked-box').show();
		$('.like-box').hide();
	}
}

function LoadFilter()
{
	var currentCategories = GetUrlParameter('categories') ? GetUrlParameter('categories').split(';') : [];

	if (currentCategories.length > 0)
		currentCategories.forEach(function (item)
		{
			if (item)
				searchCategories.push(parseInt(item));
		});

	UpdateActiveCategories();
}

function UpdateActiveCategories()
{
	$('#CategoriesList li').removeClass('active');

	$('#CategoriesList li').each(function ()
	{
		var categoryId = $(this).data('id');

		if (searchCategories.indexOf(categoryId) >= 0)
			$(this).addClass('active');
	});
}

function GetUrlParameter(sParam)
{
	var sPageURL = window.location.search.substring(1),
		sURLVariables = sPageURL.split('&'),
		sParameterName,
		i;

	for (i = 0; i < sURLVariables.length; i++)
	{
		sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] === sParam)
		{
			return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
		}
	}
	return false;
};